import { render, staticRenderFns } from "./CreateAll.vue?vue&type=template&id=b1fa2d36&scoped=true"
import script from "./CreateAll.vue?vue&type=script&lang=js"
export * from "./CreateAll.vue?vue&type=script&lang=js"
import style0 from "./CreateAll.vue?vue&type=style&index=0&id=b1fa2d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa2d36",
  null
  
)

export default component.exports